/**
 * 로그인 후 user 정보 저장함
 */

import { ILodList } from "interface/home";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SetLodState {
  lodList: ILodList[];
  setLodList: (value: any) => void;
}

const useLodListStore = create<SetLodState>()(
  persist(
    (set) => ({
      lodList: [],

      setLodList: (value) => {
        set({ lodList: value });
      },
    }),
    {
      name: "lodList-storage",
      partialize: (state) => ({
        lodList: state.lodList,
      }),
    }
  )
);

export default useLodListStore;
